import { Facebook, Instagram, ArrowUpRight } from "lucide-react";
import { LINKS, RESTAURANT } from "../data/site";

const NAV = [
  ["Home", "#home"], ["Menu", "#menu"], ["Catering", "#catering"],
  ["Gallery", "#gallery"], ["About", "#about"], ["Reviews", "#reviews"], ["Contact", "#contact"],
];

const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/8 bg-[#080808]">
    <div className="mx-auto max-w-7xl px-5 py-20 md:px-10">
      <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src="/logo.png" alt="Sri Dosa Express logo" className="h-14 w-auto" />
          <p className="mt-6 max-w-sm leading-relaxed text-mist">
            Authentic South Indian flavors, fresh ingredients and exceptional
            hospitality — in the heart of Edison, New Jersey.
          </p>
          <div className="mt-8 flex items-center gap-3">
            <a href={LINKS.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="glass rounded-full p-3 text-white/70 transition-colors duration-300 hover:text-gold">
              <Instagram size={17} />
            </a>
            <a href={LINKS.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="glass rounded-full p-3 text-white/70 transition-colors duration-300 hover:text-gold">
              <Facebook size={17} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.3em] text-gold">Explore</p>
          <nav className="mt-6 space-y-3">
            {NAV.map(([label, href]) => (
              <a key={label} href={href} data-testid={`footer-link-${label.toLowerCase()}`} className="block font-serif text-xl text-white/70 transition-colors duration-300 hover:text-gold">
                {label}
              </a>
            ))}
          </nav>
        </div>

        <div className="md:col-span-4">
          <p className="text-[11px] uppercase tracking-[0.3em] text-gold">Order & Visit</p>
          <div className="mt-6 space-y-3">
            <a href={LINKS.uberEats} target="_blank" rel="noreferrer" data-testid="footer-ubereats" className="flex items-center gap-2 font-serif text-xl text-white/70 transition-colors hover:text-gold">
              Uber Eats <ArrowUpRight size={15} />
            </a>
            <a href={LINKS.doorDash} target="_blank" rel="noreferrer" data-testid="footer-doordash" className="flex items-center gap-2 font-serif text-xl text-white/70 transition-colors hover:text-gold">
              DoorDash <ArrowUpRight size={15} />
            </a>
          </div>
          <p className="mt-8 leading-relaxed text-mist">
            {RESTAURANT.address1}<br />{RESTAURANT.address2}<br />
            <a href={RESTAURANT.phoneHref} className="text-gold">{RESTAURANT.phone}</a>
          </p>
        </div>
      </div>

      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/8 pt-8 text-[12px] uppercase tracking-[0.18em] text-white/35 md:flex-row md:items-center">
        <p>© {new Date().getFullYear()} Sri Dosa Express · Edison, NJ</p>
        <a href="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-gold">Admin</a>
      </div>
    </div>
  </footer>
);

export default Footer;
